/* eslint-disable import/prefer-default-export */
import {
  TravelAnalysisMessages,
  TranslationTravelAnalysisMessages
} from "../interfaces";

export const messages: TranslationTravelAnalysisMessages = {
  [TravelAnalysisMessages.pageTitle]: "Análise de Viagens",
  [TravelAnalysisMessages.filterButton]: "Filtrar",
  [TravelAnalysisMessages.loading]: "Carregando...",
  [TravelAnalysisMessages.totalAnalyzed]: "Total Analisado",
  [TravelAnalysisMessages.successfulTrips]: "Viagens com Sucesso",
  [TravelAnalysisMessages.successRate]: "Taxa de Sucesso",
  [TravelAnalysisMessages.alertsDetected]: "Alertas Detectados",
  [TravelAnalysisMessages.target]: "META",
  [TravelAnalysisMessages.alertDistributionTitle]: "Distribuição de Alertas por Tipo",
  [TravelAnalysisMessages.noAlertsInPeriod]: "Sem alertas no período",
  [TravelAnalysisMessages.successRatioTitle]: "Proporção Sucesso vs Alertas",
  [TravelAnalysisMessages.noData]: "Sem dados",
  [TravelAnalysisMessages.success]: "Sucesso",
  [TravelAnalysisMessages.alerts]: "Alertas",
  [TravelAnalysisMessages.efficiency]: "Eficiência",
  [TravelAnalysisMessages.geographicMonitoringTitle]: "Monitoramento Geográfico",
  [TravelAnalysisMessages.geographicMonitoringSubtitle]: "Distribuição de alertas por região de operação",
  [TravelAnalysisMessages.noGeographicData]: "Sem dados geográficos",
  [TravelAnalysisMessages.activeVehicles]: "Veículos Ativos",
  [TravelAnalysisMessages.activeAlerts]: "Alertas Ativos",
  [TravelAnalysisMessages.dashboardSubtitle]: "DASHBOARD DE OPERAÇÕES",
  [TravelAnalysisMessages.percentOfTotal]: "do total",
  [TravelAnalysisMessages.alertsListTitle]: "Detalhamento de Alertas",
  [TravelAnalysisMessages.columnVehicle]: "Veículo",
  [TravelAnalysisMessages.columnAlertType]: "Tipo de Alerta",
  [TravelAnalysisMessages.columnOrigin]: "Origem",
  [TravelAnalysisMessages.columnDestination]: "Destino",
  [TravelAnalysisMessages.columnDate]: "Data",
  [TravelAnalysisMessages.noAlertsFound]: "Nenhum alerta encontrado",
  [TravelAnalysisMessages.loadMore]: "Carregar mais",
  [TravelAnalysisMessages.close]: "Fechar",
  [TravelAnalysisMessages.tripsUnit]: "viagens",
  [TravelAnalysisMessages.columnNumDoc]: "Nº Doc",
  [TravelAnalysisMessages.columnActions]: "Ações",
  [TravelAnalysisMessages.viewAlertDetails]: "Detalhes do alerta",
  [TravelAnalysisMessages.viewTravel]: "Abrir viagem",
  [TravelAnalysisMessages.alertDetailsTitle]: "Detalhes da Análise",
  [TravelAnalysisMessages.loadingTravel]: "Carregando viagem...",
  // Metadata labels — CAN Data Stall
  [TravelAnalysisMessages.metaSource]: "Fonte de dados",
  [TravelAnalysisMessages.metaStallType]: "Tipo de travamento",
  [TravelAnalysisMessages.metaThreshold]: "Limiar",
  [TravelAnalysisMessages.metaStalledFields]: "Campos estagnados",
  [TravelAnalysisMessages.metaTotalCanPackets]: "Total de pacotes CAN",
  // Cross Day Cycle
  [TravelAnalysisMessages.metaStartDate]: "Data de início",
  [TravelAnalysisMessages.metaFinishDate]: "Data de fim",
  [TravelAnalysisMessages.metaStartDay]: "Dia de início",
  [TravelAnalysisMessages.metaFinishDay]: "Dia de fim",
  [TravelAnalysisMessages.metaDurationHours]: "Duração (horas)",
  // False Positive Discharge
  [TravelAnalysisMessages.metaTotalDischargeCommands]: "Total de comandos de descarga",
  [TravelAnalysisMessages.metaCoveredCommands]: "Comandos cobertos",
  [TravelAnalysisMessages.metaOrphanCommands]: "Comandos órfãos",
  [TravelAnalysisMessages.metaOrphanRatio]: "Taxa de órfãos (%)",
  [TravelAnalysisMessages.metaCoveredRanges]: "Períodos cobertos",
  // GPRS Connection Instability
  [TravelAnalysisMessages.metaTotalPackets]: "Total de pacotes",
  [TravelAnalysisMessages.metaMemoryCommands]: "Comandos offline real",
  [TravelAnalysisMessages.metaEffectiveRealtimeCommands]: "Comandos efetivamente tempo real",
  [TravelAnalysisMessages.metaRealtimeCommands]: "Comandos em tempo real",
  [TravelAnalysisMessages.metaMemoryRatio]: "Taxa de offline real (%)",
  [TravelAnalysisMessages.metaThresholdPercent]: "Limiar (%)",
  [TravelAnalysisMessages.metaEffectiveRealtimeThresholdSeconds]: "Limiar de tempo real efetivo (s)",
  [TravelAnalysisMessages.metaAvgDelaySeconds]: "Média de delay de transmissão (s)",
  [TravelAnalysisMessages.metaMaxDelaySeconds]: "Maior delay de transmissão (s)",
  // GPS Positioning Failure
  [TravelAnalysisMessages.metaTotalGpsPackets]: "Total de pacotes GPS",
  [TravelAnalysisMessages.metaInvalidFixCount]: "Posições inválidas",
  [TravelAnalysisMessages.metaInvalidRatio]: "Taxa de inválidos (%)",
  [TravelAnalysisMessages.metaAvgSatellites]: "Média de satélites",
  // Hardware Command Deficit
  [TravelAnalysisMessages.metaPacketCount]: "Pacotes recebidos",
  [TravelAnalysisMessages.metaExpectedPackets]: "Pacotes esperados",
  [TravelAnalysisMessages.metaMinimumRequired]: "Mínimo exigido",
  [TravelAnalysisMessages.metaDeficitPercent]: "Défice (%)",
  [TravelAnalysisMessages.metaRatePerMinute]: "Taxa por minuto",
  [TravelAnalysisMessages.metaTravelDurationMinutes]: "Duração da viagem (min)",
  // Logistics Flow Inconsistency
  [TravelAnalysisMessages.metaRequiredStates]: "Estados obrigatórios",
  [TravelAnalysisMessages.metaActualStates]: "Estados presentes",
  [TravelAnalysisMessages.metaMissingStates]: "Estados ausentes",
  [TravelAnalysisMessages.metaMissingCount]: "Quantidade em falta",
  [TravelAnalysisMessages.metaTotalStates]: "Total de estados",
  [TravelAnalysisMessages.metaNumDoc]: "Nº documento",
  // Sensor Command Deficit (IDLE)
  [TravelAnalysisMessages.metaIgnitionOnCount]: "Comandos com ignição ON",
  [TravelAnalysisMessages.metaIdleCount]: "Comandos em IDLE",
  [TravelAnalysisMessages.metaLoadingCount]: "Comandos carregando",
  [TravelAnalysisMessages.metaUnloadingCount]: "Comandos descarregando",
  [TravelAnalysisMessages.metaIdleRatio]: "Taxa de IDLE (%)",
  [TravelAnalysisMessages.successByDayTitle]: "Sucesso por Dia",
  [TravelAnalysisMessages.successByPlantTitle]: "Sucesso por Central",
  [TravelAnalysisMessages.successByRegionalTitle]: "Sucesso por Regional",
  [TravelAnalysisMessages.averageLine]: "Média",
  [TravelAnalysisMessages.noGroupedData]: "Sem dados para o período selecionado",
  [TravelAnalysisMessages.coordinateViewTitle]: "Visualização de Coordenadas",
  [TravelAnalysisMessages.coordinateViewVehicle]: "Veículo",
  [TravelAnalysisMessages.coordinateViewNF]: "NF",
  [TravelAnalysisMessages.coordinateViewGeneral]: "Geral",
  [TravelAnalysisMessages.coordinateViewContent]: "Conteúdo",
  [TravelAnalysisMessages.coordinateViewResult]: "Resultado",
  [TravelAnalysisMessages.coordinateViewGeneralData]: "Dados Gerais",
  [TravelAnalysisMessages.coordinateViewCommandContent]: "Conteúdo do Comando",
  [TravelAnalysisMessages.coordinateViewProcessingResult]: "Resultado do Processamento",
  [TravelAnalysisMessages.coordinateViewNoData]: "Sem dados",
  [TravelAnalysisMessages.coordinateViewField]: "Campo",
  [TravelAnalysisMessages.coordinateViewValue]: "Valor",
  // Alert glossary (help drawer)
  [TravelAnalysisMessages.glossaryButtonLabel]:
    "Entenda a análise",
  [TravelAnalysisMessages.glossaryDrawerTitle]:
    "Entenda a Análise de Viagens",
  [TravelAnalysisMessages.glossaryIntroTitle]: "Como funciona a análise",
  [TravelAnalysisMessages.glossaryIntroText]:
    "A viagem com nota tem ciclo completo quando registra os 5 status (A caminho, Em obra, Descarregando, Retornando e Na usina) e, se o cliente usa integração, envia todos eles. Cada viagem com falha entra em uma única causa: a que explica o primeiro status que faltou. A classificação roda sozinha quando a viagem termina ou é cancelada. Os alertas de telemetria, mais abaixo, avisam sobre a qualidade dos dados e não entram no ciclo completo.",
  [TravelAnalysisMessages.glossaryWhenLabel]: "Quando dispara",
  [TravelAnalysisMessages.glossaryAppliesLabel]: "Aplica-se a",
  [TravelAnalysisMessages.glossaryMetadataLabel]: "Detalhes capturados (metadados)",
  [TravelAnalysisMessages.glossaryAppliesAll]: "Todos os veículos",
  [TravelAnalysisMessages.glossaryAppliesMixerPump]: "Betoneiras e Caminhões-Bomba",
  [TravelAnalysisMessages.glossaryAppliesMixer]: "Betoneiras",
  [TravelAnalysisMessages.glossaryAppliesMixerDoc]: "Betoneiras com Nº documento (viagem de concreto)",
  // Glossary — GPRS Connection Instability
  [TravelAnalysisMessages.glossaryGprsTitle]: "Instabilidade de conexão GPRS",
  [TravelAnalysisMessages.glossaryGprsDesc]:
    "Indica que o rastreador perdeu o sinal de dados (GPRS) durante a viagem. Os pacotes capturados sem conexão ficam guardados na memória do equipamento e só chegam ao servidor quando o sinal volta, atrasados. Um volume alto desses pacotes atrasados sugere cobertura ruim ou problema na operadora/SIM, podendo deixar trechos sem rastro no trajeto.",
  [TravelAnalysisMessages.glossaryGprsWhen]:
    "Quando 30% ou mais dos pacotes chegaram atrasados da memória (atraso de transmissão de 60s ou mais). Pacotes de memória que chegam em menos de 60s são tratados como tempo real e não contam.",
  [TravelAnalysisMessages.glossaryGprsMeta]:
    "Os números mostram quantos pacotes vieram em tempo real, quantos vieram realmente atrasados da memória e o atraso médio e máximo de transmissão — quanto maior o atraso, pior estava o sinal.",
  // Glossary — GPS Positioning Failure
  [TravelAnalysisMessages.glossaryGpsTitle]: "Falha de posicionamento GPS",
  [TravelAnalysisMessages.glossaryGpsDesc]:
    "Indica que o equipamento não conseguiu obter uma posição confiável de satélite em boa parte da viagem. Pode ocorrer por obstrução (túneis, áreas fechadas), problema na antena ou poucos satélites visíveis, afetando a precisão do trajeto registrado.",
  [TravelAnalysisMessages.glossaryGpsWhen]:
    "Quando 30% ou mais dos pacotes com dados de GPS não tinham fixação válida de satélite (FIX inválido).",
  [TravelAnalysisMessages.glossaryGpsMeta]:
    "Mostram o total de pacotes GPS, quantos estavam sem fixação e a média de satélites captados — médias baixas reforçam a dificuldade de recepção.",
  // Glossary — Cross Day Cycle
  [TravelAnalysisMessages.glossaryCrossDayTitle]: "Ciclo transversal (D+1)",
  [TravelAnalysisMessages.glossaryCrossDayDesc]:
    "Aponta viagens que começaram em um dia e só terminaram no dia seguinte. Esse 'virar o dia' impacta o fechamento de produtividade diária, pois a viagem aparece em dois dias diferentes.",
  [TravelAnalysisMessages.glossaryCrossDayWhen]:
    "Quando o dia de início é diferente do dia de fim e a viagem durou 6 horas ou mais (viagens curtas que apenas cruzam a meia-noite são ignoradas).",
  [TravelAnalysisMessages.glossaryCrossDayMeta]:
    "Mostram as datas e os dias de início e fim, além da duração total da viagem em horas.",
  // Glossary — Hardware Command Deficit
  [TravelAnalysisMessages.glossaryHwDeficitTitle]: "Déficit de comandos de hardware enviados",
  [TravelAnalysisMessages.glossaryHwDeficitDesc]:
    "Indica que o rastreador transmitiu menos pacotes do que o esperado para a duração da viagem. Pode sinalizar equipamento com falha, desligado parte do tempo ou com problema de transmissão, reduzindo a confiabilidade dos dados da viagem.",
  [TravelAnalysisMessages.glossaryHwDeficitWhen]:
    "Quando o número de pacotes recebidos ficou abaixo de 50% do esperado (referência de 1 pacote a cada 2 minutos). Avaliado apenas em viagens com mais de 5 minutos.",
  [TravelAnalysisMessages.glossaryHwDeficitMeta]:
    "Comparam os pacotes recebidos com os esperados e mostram o déficit percentual e a taxa de pacotes por minuto.",
  // Glossary — Sensor Command Deficit (IDLE)
  [TravelAnalysisMessages.glossarySensorIdleTitle]: "Déficit de comandos de sensor ativo (IDLE elevado)",
  [TravelAnalysisMessages.glossarySensorIdleDesc]:
    "Indica que, com o veículo ligado, o balão (tambor) ficou parado — sem carregar nem descarregar — durante boa parte da viagem. Pode apontar sensor do balão com falha ou problema de comunicação, prejudicando a leitura das etapas de carga e descarga.",
  [TravelAnalysisMessages.glossarySensorIdleWhen]:
    "Quando, entre os pacotes com ignição ligada, 50% ou mais estavam com o balão parado (IDLE). Avaliado com pelo menos 10 pacotes de ignição ligada.",
  [TravelAnalysisMessages.glossarySensorIdleMeta]:
    "Mostram quantos pacotes tinham ignição ligada e, desses, quantos estavam carregando, descarregando ou parados (IDLE).",
  // Glossary — Logistics Flow Inconsistency
  [TravelAnalysisMessages.glossaryLogisticsTitle]: "Inconsistência de fluxo logístico",
  [TravelAnalysisMessages.glossaryLogisticsDesc]:
    "Aponta viagens de concreto que não passaram por todos os estados esperados do ciclo (Na usina → A caminho → Em obra → Descarregando → Retornando). A ausência de um estado pode indicar falha de detecção, trajeto atípico ou problema no apontamento da viagem.",
  [TravelAnalysisMessages.glossaryLogisticsWhen]:
    "Quando falta pelo menos um dos estados obrigatórios. Verifica a presença de cada estado, não a ordem.",
  [TravelAnalysisMessages.glossaryLogisticsMeta]:
    "Listam os estados obrigatórios, os que ocorreram e os que ficaram faltando na viagem.",
  // Glossary — CAN Data Stall
  [TravelAnalysisMessages.glossaryCanStallTitle]: "Informações de CAN travadas (completas ou parciais)",
  [TravelAnalysisMessages.glossaryCanStallDesc]:
    "Indica que dados vindos do barramento CAN do veículo (velocidade, RPM, combustível, odômetro) ficaram 'congelados', repetindo o mesmo valor por vários pacotes seguidos. Costuma apontar falha na leitura do CAN, prejudicando a telemetria do veículo.",
  [TravelAnalysisMessages.glossaryCanStallWhen]:
    "Quando algum campo do CAN repete o mesmo valor por 10 pacotes consecutivos ou mais. 'Total' = todos os campos congelados; 'Parcial' = ao menos um campo congelado.",
  [TravelAnalysisMessages.glossaryCanStallMeta]:
    "Mostram quais campos travaram, por quantos pacotes seguidos e o valor que ficou repetido.",
  // Glossary — False Positive Discharge
  [TravelAnalysisMessages.glossaryFalseDischargeTitle]: "Falsos positivos de descarga",
  [TravelAnalysisMessages.glossaryFalseDischargeDesc]:
    "Aponta comandos de descarga do balão que ocorreram fora de qualquer contexto válido de descarregamento (sem estar descarregando, na usina, em local confiável ou em evento de descarregamento indevido). Esses comandos 'órfãos' podem ser ruído de sensor ou descargas não detectadas corretamente.",
  [TravelAnalysisMessages.glossaryFalseDischargeWhen]:
    "Quando há 3 ou mais comandos de descarga órfãos (não cobertos por nenhum período de descarga conhecido).",
  [TravelAnalysisMessages.glossaryFalseDischargeMeta]:
    "Mostram o total de comandos de descarga, quantos estavam cobertos por um contexto válido e quantos ficaram órfãos.",
  // Travel cycle analysis
  [TravelAnalysisMessages.cycleKpiTicketTravels]: "viagens com nota",
  [TravelAnalysisMessages.cycleKpiComplete]: "Ciclo completo",
  [TravelAnalysisMessages.cycleKpiCompleteSub]: "viagens com os 5 status",
  [TravelAnalysisMessages.cycleKpiFailed]: "Viagens com falha",
  [TravelAnalysisMessages.cycleKpiSeeCauses]: "ver causas",
  [TravelAnalysisMessages.cycleKpiHardware]: "Hardwares a revisar",
  [TravelAnalysisMessages.cycleKpiSensors]: "sensores de descarga",
  [TravelAnalysisMessages.cycleKpiTrackers]: "rastreadores",
  [TravelAnalysisMessages.cycleKpiVehicles]: "veículos",
  [TravelAnalysisMessages.cycleImpactTitle]: "Onde estão as falhas",
  [TravelAnalysisMessages.cycleImpactHint]: "Cada viagem com falha entra em uma única causa. Clique na causa para ver os veículos e, em cada veículo, as viagens.",
  [TravelAnalysisMessages.cycleNoFailures]: "Sem falhas no período.",
  [TravelAnalysisMessages.groupEquipment]: "Equipamento no caminhão",
  [TravelAnalysisMessages.groupEquipmentDesc]: "Sensor de descarga ou rastreador não registrou o que aconteceu na viagem.",
  [TravelAnalysisMessages.groupRegistration]: "Cadastro de usina e obra",
  [TravelAnalysisMessages.groupRegistrationDesc]: "O local da usina ou da obra no cadastro não corresponde a onde o caminhão opera.",
  [TravelAnalysisMessages.groupRoutine]: "Rotina de usina e despacho",
  [TravelAnalysisMessages.groupRoutineDesc]: "Manobra logo depois de sair da usina, ou nota trocada ou substituída.",
  [TravelAnalysisMessages.groupOthers]: "Outros",
  [TravelAnalysisMessages.groupOthersDesc]: "Status registrados que não chegaram à integração e casos sem padrão.",
  [TravelAnalysisMessages.outcomeComplete]: "Ciclo completo",
  [TravelAnalysisMessages.outcomeSensorStopped]: "Sensor de descarga parado",
  [TravelAnalysisMessages.outcomeSensorStoppedDesc]: "Chegou à obra, mas o sensor não registra a descarga em quase nenhuma viagem.",
  [TravelAnalysisMessages.outcomeSensorStoppedAction]: "Manutenção do sensor",
  [TravelAnalysisMessages.outcomeSensorIntermittent]: "Sensor de descarga intermitente",
  [TravelAnalysisMessages.outcomeSensorIntermittentDesc]: "O sensor registra a descarga em parte das viagens e falha nas outras.",
  [TravelAnalysisMessages.outcomeSensorIntermittentAction]: "Revisar sensor e cabo",
  [TravelAnalysisMessages.outcomeDischargeOneOff]: "Descarga não registrada (pontual)",
  [TravelAnalysisMessages.outcomeDischargeOneOffDesc]: "Caminhão com o sensor em dia que, numa viagem isolada, não registrou a descarga.",
  [TravelAnalysisMessages.outcomeDischargeOneOffAction]: "Acompanhar",
  [TravelAnalysisMessages.outcomeTrackerWithoutSignal]: "Rastreador sem sinal",
  [TravelAnalysisMessages.outcomeTrackerWithoutSignalDesc]: "O rastreador não transmitiu durante a viagem.",
  [TravelAnalysisMessages.outcomeTrackerWithoutSignalAction]: "Manutenção do rastreador",
  [TravelAnalysisMessages.outcomeInactivePlant]: "Usina inativa no cadastro",
  [TravelAnalysisMessages.outcomeInactivePlantDesc]: "A usina de origem está inativa: o caminhão não é reconhecido nela e a viagem não começa.",
  [TravelAnalysisMessages.outcomeInactivePlantAction]: "Reativar a usina em Cadastro › Locais",
  [TravelAnalysisMessages.outcomeJobsiteNotDetected]: "Chegada na obra não detectada",
  [TravelAnalysisMessages.outcomeJobsiteNotDetectedDesc]: "O caminhão saiu da usina, mas não foi reconhecido dentro da obra.",
  [TravelAnalysisMessages.outcomeJobsiteNotDetectedAction]: "Ajustar o local da obra",
  [TravelAnalysisMessages.outcomeDischargeOutsideJobsite]: "Descarga fora da área da obra",
  [TravelAnalysisMessages.outcomeDischargeOutsideJobsiteDesc]: "O sensor registrou a descarga fora da área cadastrada da obra.",
  [TravelAnalysisMessages.outcomeDischargeOutsideJobsiteAction]: "Ajustar o local da obra pelo alerta",
  [TravelAnalysisMessages.outcomeJobsiteNextToPlant]: "Obra junto da usina",
  [TravelAnalysisMessages.outcomeJobsiteNextToPlantDesc]: "A obra fica a menos de 500 m da usina: o caminhão não sai da área da usina e a viagem não começa.",
  [TravelAnalysisMessages.outcomeJobsiteNextToPlantAction]: "Conferir as áreas da usina e da obra",
  [TravelAnalysisMessages.outcomeShortPlantExit]: "Saída curta da usina",
  [TravelAnalysisMessages.outcomeShortPlantExitDesc]: "Saiu e voltou à usina em até 10 minutos, numa manobra ou pesagem, e isso encerrou a viagem antes da entrega.",
  [TravelAnalysisMessages.outcomeShortPlantExitAction]: "Manobra e pesagem dentro da área da usina",
  [TravelAnalysisMessages.outcomeReplacedTicket]: "Nota substituída por outra",
  [TravelAnalysisMessages.outcomeReplacedTicketDesc]: "O caminhão rodou outra nota e esta não começou: foi cancelada pela seguinte ou ficou na fila.",
  [TravelAnalysisMessages.outcomeReplacedTicketAction]: "Conferir a ordem das notas",
  [TravelAnalysisMessages.outcomeTwoTickets]: "Duas notas no mesmo caminhão",
  [TravelAnalysisMessages.outcomeTwoTicketsDesc]: "Duas notas para o mesmo caminhão com menos de 15 minutos entre elas: só a última segue.",
  [TravelAnalysisMessages.outcomeTwoTicketsAction]: "Uma nota por carga",
  [TravelAnalysisMessages.outcomeIntegrationNotSent]: "Status não enviado à integração",
  [TravelAnalysisMessages.outcomeIntegrationNotSentDesc]: "Os 5 status foram registrados, mas algum não foi enviado à integração.",
  [TravelAnalysisMessages.outcomeIntegrationNotSentAction]: "Conferir o log da integração",
  [TravelAnalysisMessages.outcomeOther]: "Sem padrão identificado",
  [TravelAnalysisMessages.outcomeOtherDesc]: "A sequência de status não se encaixa nas causas acima.",
  [TravelAnalysisMessages.outcomeOtherAction]: "Analisar a viagem",
  [TravelAnalysisMessages.cyclePlacesByRegional]: "Ciclo completo por Regional",
  [TravelAnalysisMessages.cyclePlacesByPlant]: "Ciclo completo por Central",
  [TravelAnalysisMessages.cyclePlacesHint]: "Clique no nome para filtrar a tela por ele.",
  [TravelAnalysisMessages.toggleRegional]: "Regional",
  [TravelAnalysisMessages.togglePlant]: "Central",
  [TravelAnalysisMessages.toggleTable]: "Tabela",
  [TravelAnalysisMessages.toggleChart]: "Gráfico",
  [TravelAnalysisMessages.columnRegional]: "Regional",
  [TravelAnalysisMessages.columnPlant]: "Central",
  [TravelAnalysisMessages.columnTravels]: "Viagens",
  [TravelAnalysisMessages.columnCycleComplete]: "Ciclo completo",
  [TravelAnalysisMessages.columnFailuresByType]: "Falhas por tipo",
  [TravelAnalysisMessages.columnTopCause]: "Principal causa",
  [TravelAnalysisMessages.fewTravels]: "poucas viagens",
  [TravelAnalysisMessages.ofTravels]: "das viagens",
  [TravelAnalysisMessages.noRegional]: "Sem regional",
  [TravelAnalysisMessages.hardwareTitle]: "Hardwares a verificar",
  [TravelAnalysisMessages.hardwareHint]: "Veículos cujo sensor de descarga ou rastreador fez viagens falharem no período. O botão da linha mostra as viagens.",
  [TravelAnalysisMessages.hwAll]: "Todos",
  [TravelAnalysisMessages.hwSensorStopped]: "Sensor parado",
  [TravelAnalysisMessages.hwSensorIntermittent]: "Sensor intermitente",
  [TravelAnalysisMessages.hwTracker]: "Rastreador sem sinal",
  [TravelAnalysisMessages.columnProblem]: "Problema",
  [TravelAnalysisMessages.columnDischarges]: "Descargas registradas",
  [TravelAnalysisMessages.columnFailedTravels]: "Viagens com falha",
  [TravelAnalysisMessages.columnLastUnload]: "Última descarga",
  [TravelAnalysisMessages.columnLastSignal]: "Último sinal",
  [TravelAnalysisMessages.wordOf]: "de",
  [TravelAnalysisMessages.hwSensorShort]: "sensor",
  [TravelAnalysisMessages.hwTrackerShort]: "rastreador",
  [TravelAnalysisMessages.noHardware]: "Nenhum hardware a verificar no filtro",
  [TravelAnalysisMessages.cycleDrilldownTitle]: "Detalhamento de Falhas",
  [TravelAnalysisMessages.columnMainPlant]: "Central principal",
  [TravelAnalysisMessages.columnTravelsWithCause]: "Viagens com esta causa",
  [TravelAnalysisMessages.columnShareOfVehicle]: "% das viagens do veículo",
  [TravelAnalysisMessages.columnRegisteredStates]: "Status registrados",
  [TravelAnalysisMessages.columnCause]: "Causa",
  [TravelAnalysisMessages.stateRegistered]: "registrado",
  [TravelAnalysisMessages.stateNotRegistered]: "não registrado",
  [TravelAnalysisMessages.telemetryTitle]: "Alertas de telemetria",
  [TravelAnalysisMessages.telemetryHint]: "Avisos sobre a qualidade dos dados do rastreador e dos sensores. Não entram no ciclo completo.",
  [TravelAnalysisMessages.glossaryCyclesSection]: "Causas de falha do ciclo",
  [TravelAnalysisMessages.glossaryAlertsSection]: "Alertas de telemetria",
  [TravelAnalysisMessages.glossaryWhatToDo]: "O que fazer",
  [TravelAnalysisMessages.glossarySensorHealth]: "Sensor parado: registrou a descarga em menos de 10% das viagens que chegaram à obra no período. Intermitente: entre 10% e 80%. Com menos de 5 viagens na obra, conta como parado quando não registra descarga há mais de 14 dias.",
  [TravelAnalysisMessages.dailyTitle]: "Ciclo completo por dia",
  [TravelAnalysisMessages.dailyHint]: "Só dias com viagens. A linha pontilhada verde é a média do período e a tracejada cinza mostra a tendência dos últimos 5 dias.",
  [TravelAnalysisMessages.movingAverage]: "Média móvel de 5 dias",
  [TravelAnalysisMessages.periodAverage]: "Média do período",
  [TravelAnalysisMessages.averageShort]: "média",
  [TravelAnalysisMessages.generalLine]: "Geral",
  [TravelAnalysisMessages.selectedPlaces]: "{{count}} selecionadas",
  [TravelAnalysisMessages.chartNotePlaces]: "Escolha uma ou várias no seletor. A linha Geral soma todas e a pontilhada verde é a média do período. Dias com menos de 5 viagens ficam de fora da linha.",
  [TravelAnalysisMessages.backTo]: "Voltar para {{name}}",
  [TravelAnalysisMessages.tileTravels]: "Viagens",
  [TravelAnalysisMessages.tileShareOfFilter]: "Das viagens do filtro",
  [TravelAnalysisMessages.tileVehicles]: "Veículos",
  [TravelAnalysisMessages.tileGroup]: "Grupo",
  [TravelAnalysisMessages.whatItIs]: "O que é",
  [TravelAnalysisMessages.byRegional]: "Por regional",
  [TravelAnalysisMessages.byPlant]: "Por central",
  [TravelAnalysisMessages.vehiclesWithCause]: "Veículos com esta causa ({{count}})",
  [TravelAnalysisMessages.tileTravelsInPeriod]: "Viagens no período",
  [TravelAnalysisMessages.tileWithFailure]: "Com falha",
  [TravelAnalysisMessages.tileWithThisCause]: "Com esta causa",
  [TravelAnalysisMessages.tilePlant]: "Central",
  [TravelAnalysisMessages.tileSensor]: "Sensor de descarga",
  [TravelAnalysisMessages.sensorStopped]: "Parado",
  [TravelAnalysisMessages.sensorIntermittent]: "Intermitente",
  [TravelAnalysisMessages.sensorOk]: "Em dia",
  [TravelAnalysisMessages.sensorDetail]: "descarga em {{pct}} de {{reached}} viagens na obra · última {{date}}",
  [TravelAnalysisMessages.failuresByCause]: "Falhas por causa",
  [TravelAnalysisMessages.failedTravelsCount]: "Viagens com falha ({{count}})",
  [TravelAnalysisMessages.columnDetails]: "Detalhes",
  [TravelAnalysisMessages.stateOnTheWay]: "A caminho",
  [TravelAnalysisMessages.stateJobsite]: "Em obra",
  [TravelAnalysisMessages.stateDischarging]: "Descarregando",
  [TravelAnalysisMessages.stateReturning]: "Retornando",
  [TravelAnalysisMessages.statePlant]: "Na usina",
  [TravelAnalysisMessages.glossaryCausesCount]: "{{count}} causas",
  [TravelAnalysisMessages.glossaryAlertsCount]: "{{count}} alertas"
};
